import { AddButton } from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';

type NewAlertHeaderActionProps = {
  assetId: string;
  routineId: string;
  /**
   * Runs before navigation. Use to drive a slide transition (e.g.
   * `slideLayout.onSlideChange(SlideAction.NEXT)`) before pushing the new-alert
   * route. Awaited so async transitions resolve before the navigation fires.
   */
  onBeforeNavigate?: () => void | Promise<void>;
  accessibilityLabel?: string;
};

export const NewAlertHeaderAction = ({
  assetId,
  routineId,
  onBeforeNavigate,
  accessibilityLabel,
}: NewAlertHeaderActionProps) => {
  const navigate = useNavigate();

  const handlePress = async () => {
    await onBeforeNavigate?.();
    navigate(`/assets/${assetId}/routines/${routineId}/alerts/new`);
  };

  return (
    <AddButton
      variant="header"
      onPress={() => void handlePress()}
      accessibilityLabel={accessibilityLabel}
    />
  );
};
